import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./features/combineReducers";

export const store = configureStore({
  reducer: rootReducer,
});
